// @ts-check
import QuickAssignOrSchedule from './QuickAssignOrSchedule';

export default QuickAssignOrSchedule;
